import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { ICourseReviewsResponse } from "@api/courses/reviews/types";
import { createPatchApi } from "@api/util/createPatchApi";
import type { IReviewDto, IReviewGetAllParams } from "@api/reviews/types";
import type { ICourseReviewStatesResponse } from "@api/courses/reviews/states/types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICourseReviewsResponse>> & {
    metadata?: ICourseReviewStatesResponse;
  },
  IPathBaseParam,
  IPaginationParams & IReviewGetAllParams
>("courseReviews");

const patchApis = createPatchApi<
  IApiResponse<unknown>,
  IPathByIdParam,
  IReviewDto
>("courseReviews");

export const courseReviews = {
  ...getAllApis,
  ...patchApis,
};
